<div class="live-status" [class.live-status--connected]="connected" [class.live-status--disconnected]="!connected">
  <span class="live-status__dot"></span>
  <span class="live-status__text">{{ connected ? 'Conectado' : 'Sin conexión' }}</span>
</div>
